import Box from '@components/Box';
import ButtonWithTimer, { ButtonWithTimerType } from '@components/ButtonWithTimer/ButtonWithTimer';
import DigitInput from '@components/DigitInput';
import FormErrorMessage from '@components/FormErrorMessage';
import parse from 'html-react-parser';
import { Button, ButtonSize, ButtonType } from '@components/Button';
import { Grid, Column, Row } from '@components/Grid';
import { Text, TextType, TextSize } from '@components/Text';
import { useMutation } from 'react-query';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { verifyPhone } from '@api/apiClient/signUp';

export interface ConfirmPhoneType {
  code: string;
}

interface ConfirmPhoneProps {
  onSuccess: (phone: string) => void;
  goBack?: () => void;
  phone: string;
  resend: () => void;
  isLoading: boolean;
}

const ConfirmPhone = ({
  onSuccess,
  goBack,
  phone,
  isLoading,
  resend,
}: ConfirmPhoneProps) => {
  const [code, setCode] = useState("");

  useEffect(() => {
    verifyMutation.reset();
    if (code.trim().length === 4) verifyMutation.mutate({ code })
  }, [code])

  const verifyMutation = useMutation({
    mutationFn: verifyPhone,
    onSuccess: () => onSuccess(phone),
  });

  const { t } = useTranslation();

  return (
    <Grid>
      <Row>
        <Column phone={12}>
          <Box pb={3}>
            <Text type={TextType.H1}>
              {t("signUp.confirm.title")}
            </Text>
          </Box>
        </Column>
      </Row>
      <Row>
        <Column phone={12}>
          <Box pb={10}>
            <Text
                size={TextSize.M}
                type={TextType.INLINE}
            >
              {parse(t('signUp.confirm.description', { phone: phone }))}
            </Text>
            {' '}
            {goBack && (
                <Button
                    title={t('signUp.confirm.changeLink')}
                    type={ButtonType.LINK}
                    size={ButtonSize.S}
                    onClick={goBack}
                />
            )}
          </Box>
        </Column>
      </Row>

      <Row>
        <Column phone={12}>
          <Box pb={verifyMutation.isError ? 0 : 5}>
            <DigitInput
                disabled={verifyMutation.isLoading}
                hasError={verifyMutation.isError}
                length={4}
                name="code"
                onChange={setCode}
                value={code}
            />
          </Box>
        </Column>
      </Row>
      {verifyMutation.isError && (
          <Column phone={12}>
            <Box pb={5}>
              <FormErrorMessage error={verifyMutation.error} />
            </Box>
          </Column>
      )}
      <Row>
        <Column phone={12}>
          <ButtonWithTimer
            onClick={() => {
              resend();
              setCode('');
              verifyMutation.reset();
            }}
            pending={isLoading}
            label={t("signUp.confirm.resend")}
            type={ButtonWithTimerType.LINK}
            startTimerFromOutside
          />
        </Column>
      </Row>
    </Grid>
  );
};

export default ConfirmPhone;
